
import {
	Component, Vue,
} from 'vue-property-decorator';

const TEST_ID = 'Kloans-PaymentStatusWidget';

@Component
export default class PaymentStatusWidget extends Vue {
	public TEST_ID = TEST_ID;
}
